import { Link } from 'react-router-dom';

interface BreadcrumbProps {
  /** Text label for the back link (displayed uppercase) */
  label: string;
  /** Route path to navigate back to */
  to: string;
}

/**
 * Back-navigation breadcrumb.
 * Renders "← LABEL" in DM Sans 12px uppercase tracking-wide muted color.
 * Uses React Router Link for client-side navigation (no full page reload).
 */
export function Breadcrumb({ label, to }: BreadcrumbProps) {
  return (
    <Link
      to={to}
      aria-label={`Back to ${label}`}
      className="inline-flex items-center gap-1 text-[12px] font-medium uppercase tracking-wide text-[var(--color-text-placeholder)] hover:text-[var(--color-text-muted)] transition-colors"
      data-testid="breadcrumb"
    >
      ← {label.toUpperCase()}
    </Link>
  );
}
